import { connect } from 'fluent'
import * as React from 'react'

import { Video, Loader, Root } from './elements'

interface Props {
  src: string
  className?: string

  height?: number
  width?: number
  maxWidth?: number
  maxHeight?: number
  controls?: boolean
}

/**
 * Expandable video
 */
const ExpandableVideo = connect<Props>()
  .with(({ state, signals, props }) => ({
    toggle: signals.modal
  }))
  .toClass(
    props =>
      class ExpandableVideo extends React.PureComponent<typeof props> {
        state = {
          type: 'loading'
        }

        open() {
          const { src, toggle, controls } = this.props
          if (src && !controls) {
            toggle({
              open: true,
              type: 'video',
              data: src
            })
          }
        }

        render() {
          const {
            className,
            height,
            width,
            maxHeight,
            maxWidth,
            src,
            controls
          } = this.props

          return (
            <Root
              className={className || null}
              onClick={controls ? undefined : this.open.bind(this)}
              maxHeight={maxHeight}
              maxWidth={maxWidth}
              height={height}
              width={width}
            >
              <Video
                autoPlay={!controls}
                loop={!controls}
                muted={!controls}
                playsInline
                controls={!!controls}
                preload={controls ? 'metadata' : 'auto'}
                onCanPlay={() => this.setState({ type: 'loaded' })}
                onError={() => this.setState({ type: 'error' })}
                src={src}
              />
              {this.state.type === 'loading' && <Loader />}
            </Root>
          )
        }
      }
  )

export default ExpandableVideo



// WEBPACK FOOTER //
// ./src/modules/styled-elements/ExpandableVideo/index.tsx